import { GraphQLClient, RequestMiddleware, ResponseMiddleware, Variables } from "graphql-request";

export type BaseGqlClientType = {
  requestMiddleware?: RequestMiddleware<Variables> | undefined;
  responseMiddleware?: ResponseMiddleware | undefined;
};
export class BaseGqlClient {
  public client: GraphQLClient;
  constructor(props?: BaseGqlClientType) {
    this.client = new GraphQLClient(process.env.NEXT_PUBLIC_URL_SERVER_GRAPHQL as string, {
      credentials: "include",
      mode: "cors",
      ...(props?.requestMiddleware && { requestMiddleware: props.requestMiddleware }),
      ...(props?.responseMiddleware && { responseMiddleware: props.responseMiddleware }),
    });
  }
}

export class BaseServerGqlClient {
  public client: GraphQLClient;
  constructor(props?: BaseGqlClientType) {
    this.client = new GraphQLClient(process.env.NEXT_PUBLIC_SSR_URL_SERVER_GRAPHQL as string, {
      credentials: "include",
      mode: "cors",
      ...(props?.requestMiddleware && { requestMiddleware: props.requestMiddleware }),
      ...(props?.responseMiddleware && { responseMiddleware: props.responseMiddleware }),
    });
  }
}
